import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { messageService } from '../message.service';
import { qmsService } from '../qms/qms.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SessionTimeoutService } from '../session-timeout-dialog/session-timeout.service';

@Component({
  selector: 'app-training-preview',
  templateUrl: './training-preview.component.html',
  styleUrls: ['./training-preview.component.scss']
})
export class TrainingPreviewComponent implements OnInit {

  trainingData: any;
  contentList: any = [];
  content: any = {};
  userprofilename: any;
  dropDownForCategories = [];
  topNavService: any;

  constructor(private readonly appService: AppService, private readonly router: Router, private readonly _location: Location,
    private readonly qmsService: qmsService,
    public dialog: MatDialog, private readonly message: messageService, private readonly sessionTimeoutService: SessionTimeoutService) {

    const data: any = router.getCurrentNavigation()?.extras.state;
    this.dropDownForCategories = data['category'];
    this.trainingData = data['trainingObj'];
  }

  documentData: any = {};
  oneQmsOrgUsersDetails: any;
  ngOnInit(): void {
    let userData = JSON.parse(sessionStorage.getItem("userDetails") ?? '{}')
    this.userprofilename = userData.userNameAtApplication;
    this.oneQmsOrgUsersDetails = JSON.parse(sessionStorage.getItem('oneQmsOrgUsersDetails') || '{}');
    this.isProcessing = true;
    this.appService.getContentsList(this.trainingData['trainingId'],
      this.trainingData['version']).subscribe((data: any) => {
        let individualData: any = [];
        if (this.message.showIndividualContentIfFromTrainingsContentPage && (individualData = data.filter((item: any) => item.contentId == this.message.individualContentsContentId))) {
          data = individualData;
          this.contentList = data;
          this.message.showIndividualContentIfFromTrainingsContentPage = false;
          this.message.sendBackToContent = true;
        } else {
          this.contentList = data;
        }

        this.isProcessing = false;
        if (data.length > 0) {
          this.content = this.contentList[0];
          this.clickedContent = this.contentList[0];
          this.currentContent = this.contentList[0].contentSeq;
          if (data[0].isQuestionContent == "Y") {
            this.isProcessing = true;
            this.appService.getContentAssessmentList(this.contentList[0]['trainingId'],
              this.contentList[0]['version'], this.contentList[0]['contentId']).subscribe((data: any) => {
                this.contentList[0].questionsList = data;
                this.isProcessing = false;
                const initialContent = this.contentList?.[0];
                for (const question of data ?? []) {
                  this.getOptionsForQuestion(question, initialContent);
                }

              })
          } else {
            if (data[0].documentId) {
              this.isProcessing = true;
              data[0]['trainingStatus'] = this.trainingData['status'];
              this.appService.getDocumentByDocumentId(
                data[0].documentId, data[0].documentVersion).subscribe((data1: any) => {
                  if (data1.length > 0) {
                    this.documentData = data1[0];
                    this.isProcessing = false;
                    data[0]['contentExtn'] = this.documentData['documentExtn'];

                    let obj = {
                      trainingId: this.trainingData['trainingId'],
                      version: this.trainingData['version'],
                      contentId: data[0]['contentId'],
                      status: this.trainingData['status'],
                      contentExtn: data[0]['contentExtn']
                    }
                    this.appService.getDocumentsToViewForLaunch(obj)
                      .subscribe((data1: any) => {
                        if (data[0]['contentExtn'] == 'txt' || data[0]['contentExtn'] == 'TXT') {
                          let blob = new Blob([data1.body], { type: 'text/plain' });
                          let url = URL.createObjectURL(blob);
                          let iframee: any = document.getElementById("myIframe");
                          iframee.oncontextmenu = function () { return false; };
                          iframee.src = url + "#toolbar=0";
                        } else
                          if (data[0]['contentExtn'] == 'mp4') {
                            let blob = new Blob([data1.body], { type: "video/mp4" });
                            let url = URL.createObjectURL(blob);
                            let video = <HTMLVideoElement>document.getElementById('videoarea');
                            video.src = url;
                            video.load();
                            video.crossOrigin = 'anonymous';
                            video.play();
                          } else if (data[0]['contentExtn'] == 'mp3') {
                            let blob = new Blob([data1.body], { type: "audio/mpeg" });
                            let url = URL.createObjectURL(blob);
                            let audio = <HTMLAudioElement>document.getElementById('audio');
                            audio.src = url;
                            audio.crossOrigin = 'anonymous';
                            audio.load();
                            audio.play();
                          } else if (data[0]['contentExtn'] == 'jpg' || data[0]['contentExtn'] == 'jpeg' ||
                            data[0]['contentExtn'] == 'png' || data[0]['contentExtn'] == 'JPG' ||
                            data[0]['contentExtn'] == 'PNG' || data[0]['contentExtn'] == 'JPEG') {
                            let blob = new Blob([data1.body], { type: "image/*" });
                            let url = URL.createObjectURL(blob);
                            let image: any = document.getElementById("picture");
                            image.src = url;
                          } else if (data[0].contentExtn == 'pdf' ||
                            data[0].contentExtn == 'docx' ||
                            data[0].contentExtn == 'xlsx' ||
                            data[0].contentExtn == 'ppt' ||
                            data[0].contentExtn == 'pptx') {

                            let contentType = data1.headers.get('content-type');
                            this.viewerData = {
                              body: data1.body,
                              contentType: contentType,
                              extn: data[0]['contentExtn']
                            }
                          }

                      })
                  }
                })
            } else {
              this.isProcessing = true;
              this.appService.getDocumentsToView(this.contentList[0]['contentId'],
                this.contentList[0]['trainingId'], this.contentList[0]['version'])
                .subscribe((data: any) => {
                  this.isProcessing = false;
                  if (this.contentList[0]['contentExtn'] == 'txt' || this.contentList[0]['contentExtn'] == 'TXT') {
                    let blob = new Blob([data.body], { type: 'text/plain' });
                    let url = URL.createObjectURL(blob);
                    let iframee: any = document.getElementById("myIframe");
                    iframee.oncontextmenu = function () { return false; };
                    iframee.src = url + "#toolbar=0";
                  } else if (this.contentList[0]['contentExtn'] == 'mp4') {
                    let blob = new Blob([data.body], { type: "video/mp4" });
                    let url = URL.createObjectURL(blob);
                    let video = <HTMLVideoElement>document.getElementById('videoarea');
                    video.src = url;
                    video.crossOrigin = 'anonymous';
                    video.load();
                    video.play();
                  } else if (this.contentList[0]['contentExtn'] == 'mp3') {
                    let blob = new Blob([data.body], { type: "audio/mpeg" });
                    let url = URL.createObjectURL(blob);
                    let audio = <HTMLAudioElement>document.getElementById('audio');
                    audio.src = url;
                    audio.crossOrigin = 'anonymous';
                    audio.load();
                    audio.play();
                  } else if (this.contentList[0]['contentExtn'] == 'jpg' || this.contentList[0]['contentExtn'] == 'jpeg' ||
                    this.contentList[0]['contentExtn'] == 'png' || this.contentList[0]['contentExtn'] == 'JPG' ||
                    this.contentList[0]['contentExtn'] == 'PNG' || this.contentList[0]['contentExtn'] == 'JPEG') {
                    let blob = new Blob([data.body], { type: "image/*" });
                    let url = URL.createObjectURL(blob);
                    let image: any = document.getElementById("picture");
                    image.src = url;
                  } else if (this.contentList[0].contentExtn == 'pdf' ||
                    this.contentList[0].contentExtn == 'docx' ||
                    this.contentList[0].contentExtn == 'xlsx' ||
                    this.contentList[0].contentExtn == 'ppt' ||
                    this.contentList[0].contentExtn == 'pptx') {
                    let obj = {
                      trainingId: this.contentList[0]['trainingId'],
                      version: this.contentList[0]['version'],
                      contentId: this.contentList[0]['contentId'],
                      status: this.trainingData['status'],
                      contentExtn: this.contentList[0]['contentExtn']
                    }
                    this.appService.getDocumentsToViewForLaunch(obj)
                      .subscribe((data: any) => {
                        let contentType = data.headers.get('content-type');
                        this.viewerData = {
                          body: data.body,
                          contentType: contentType,
                          extn: this.contentList[0]['contentExtn']
                        }
                      })
                  }

                })
            }
          }
        }
      })
  }

  getOptionsForQuestion(question: any, content: any) {
    this.isProcessing = true;
    this.appService.getQuestionOptionsList(question['trainingId'],
      question['version'], question['contentId'], question['questionId']).subscribe((data: any) => {
        question['optionsList'] = data;
        this.isProcessing = false;
      })
  }

  clickedContent: any;
  isProcessing: boolean = false;
  viewerData: any;
  openForPreview(event: any, content: any) {
    this.currentContent = content.contentSeq;
    this.content = content;
    this.clickedContent = content;
    if (content.isQuestionContent == "Y") {
      this.isProcessing = true;
      this.appService.getContentAssessmentList(content['trainingId'],
        content['version'], content['contentId']).subscribe((data: any) => {
          content.questionsList = data;
          this.isProcessing = false;
          for (const question of data ?? []) {
            this.getOptionsForQuestion(question, content);
          }

        })
    } else {
      if (content.documentId) {
        this.isProcessing = true;
        content['trainingStatus'] = this.trainingData['status'];
        this.appService.getDocumentByDocumentId(
          content.documentId, content.documentVersion).subscribe((data1: any) => {
            if (data1.length > 0) {
              this.documentData = data1[0];
              this.isProcessing = false;
              content['contentExtn'] = this.documentData['documentExtn'];

              let obj = {
                trainingId: this.trainingData['trainingId'],
                version: this.trainingData['version'],
                contentId: content['contentId'],
                status: this.trainingData['status'],
                contentExtn: content['contentExtn']
              }
              this.appService.getDocumentsToViewForLaunch(obj)
                .subscribe((data: any) => {
                  if (content['contentExtn'] == 'txt' || content['contentExtn'] == 'TXT') {
                    let blob = new Blob([data.body], { type: 'text/plain' });
                    let url = URL.createObjectURL(blob);
                    let iframee: any = document.getElementById("myIframe");
                    iframee.oncontextmenu = function () { return false; };
                    iframee.src = url + "#toolbar=0";
                  } else
                    if (content['contentExtn'] == 'mp4') {
                      let blob = new Blob([data.body], { type: "video/mp4" });
                      let url = URL.createObjectURL(blob);
                      let video = <HTMLVideoElement>document.getElementById('videoarea');
                      video.src = url;
                      video.load();
                      video.crossOrigin = 'anonymous';
                      video.play();
                    } else if (content['contentExtn'] == 'mp3') {
                      let blob = new Blob([data.body], { type: "audio/mpeg" });
                      let url = URL.createObjectURL(blob);
                      let audio = <HTMLAudioElement>document.getElementById('audio');
                      audio.src = url;
                      audio.crossOrigin = 'anonymous';
                      audio.load();
                      audio.play();
                    } else if (content['contentExtn'] == 'jpg' || content['contentExtn'] == 'jpeg' ||
                      content['contentExtn'] == 'png' || content['contentExtn'] == 'JPG' ||
                      content['contentExtn'] == 'PNG' || content['contentExtn'] == 'JPEG') {
                      let blob = new Blob([data.body], { type: "image/*" });
                      let url = URL.createObjectURL(blob);
                      let image: any = document.getElementById("picture");
                      image.src = url;
                    } else if (content.contentExtn == 'pdf' ||
                      content.contentExtn == 'docx' ||
                      content.contentExtn == 'xlsx' ||
                      content.contentExtn == 'ppt' ||
                      content.contentExtn == 'pptx') {
                      let obj = {
                        trainingId: content['trainingId'],
                        version: content['version'],
                        contentId: content['contentId'],
                        status: this.trainingData['status'],
                        contentExtn: content['contentExtn']
                      }
                      this.appService.getDocumentsToViewForLaunch(obj)
                        .subscribe((data: any) => {
                          let contentType = data.headers.get('content-type');
                          this.viewerData = {
                            body: data.body,
                            contentType: contentType,
                            extn: content['contentExtn']
                          }
                        })
                    }

                })
            }
          })
      } else {
        this.isProcessing = true;
        this.appService.getDocumentsToView(content['contentId'], content['trainingId'], content['version'])
          .subscribe((data: any) => {
            this.isProcessing = false;
            if (content['contentExtn'] == 'txt' || content['contentExtn'] == 'TXT') {
              let blob = new Blob([data.body], { type: 'text/plain' });
              let url = URL.createObjectURL(blob);
              let iframee: any = document.getElementById("myIframe");
              iframee.oncontextmenu = function () { return false; };
              iframee.src = url + "#toolbar=0";
            } else if (content['contentExtn'] == 'mp4') {
              let blob = new Blob([data.body], { type: "video/mp4" });
              let url = URL.createObjectURL(blob);
              let video = <HTMLVideoElement>document.getElementById('videoarea');
              video.src = url;
              video.crossOrigin = 'anonymous';
              video.load();
              video.play();
            } else if (content['contentExtn'] == 'mp3') {
              let blob = new Blob([data.body], { type: "audio/mpeg" });
              let url = URL.createObjectURL(blob);
              let audio = document.getElementById('audio') as HTMLAudioElement;
              audio.src = url;
              audio.crossOrigin = 'anonymous';
              audio.load();
              audio.play();
            } else if (content['contentExtn'] == 'jpg' || content['contentExtn'] == 'jpeg' ||
              content['contentExtn'] == 'png' || content['contentExtn'] == 'JPG' ||
              content['contentExtn'] == 'PNG' || content['contentExtn'] == 'JPEG') {
              let blob = new Blob([data.body], { type: "image/*" });
              let url = URL.createObjectURL(blob);
              let image: any = document.getElementById("picture");
              image.src = url;
            } else if (content.contentExtn == 'pdf' ||
              content.contentExtn == 'docx' ||
              content.contentExtn == 'xlsx' ||
              content.contentExtn == 'ppt' ||
              content.contentExtn == 'pptx') {
              let contentType = data.headers.get('content-type');
              this.viewerData = {
                body: data.body,
                contentType: contentType,
                extn: content['contentExtn']
              }
            }

          })
      }
    }
  }

  closePreview() {


    this.isProcessing = true;
    this.appService.getAllCategoriesList().subscribe((data: any) => {
      this.dropDownForCategories = data;
      this.appService.getTrainingByTrainingId(this.content.trainingId, this.content.version)
        .subscribe((data: any) => {
          this.isProcessing = false;
          console.log(" data[0]====", data[0]);
          this.appService.setTrainingDetails(this.dropDownForCategories, data[0]);
          this.message.breadcrumbData.thirdLevel = "Add Training";

          this.router.navigate(['/dashboard/addTraining']);
        })
    })

    // this.isProcessing = true;

    // this.router.navigate(['/dashboard/addTraining']).then(() => {
    //   this.isProcessing = false; // Optional: only if you want to reset after navigation
    // });
  }



  visibleNotificationPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('notificationPopup', { static: true }) notificationPopup: TemplateRef<any>;
  notificationPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  openNotifications() {
    this.qmsService.activityId = null;
    this.visibleNotificationPopup = this.dialog.open(this.notificationPopup, this.notificationPopupConfig);
  }

  cancelNotificationPopup() {
    this.visibleNotificationPopup.close();
  }


  public currentContent: any;

  onUserActivity(): void {
    this.sessionTimeoutService.notifyActivity();
  }
}
